import React from "react";

const NotFoundPage = () => {
  return <h1 className="d-flex justify-content-center">Page Not Found</h1>;
};

export default NotFoundPage;
